import PortalIdParser from 'PortalIdParser';
export const openManagePropertiesPage = ({
  objectTypeId,
  objectId
}) => {
  window.open(`${window.location.origin}/contacts/${PortalIdParser.get()}/record/${objectTypeId}/${objectId}/properties?search=phone`, '_self');
};